import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import useAgreementDownloadURL from "../../../hooks/useAgreementDownloadURL";

export default function DownloadAgreementDropdownItem({ agreement }) {
	const { t } = useTranslation();

	const [signedAgreementUrl] = useAgreementDownloadURL({ agreement });

	return (
		<Dropdown.Item
			as="a"
			text={t("download", "Download")}
			target="_blank"
			disabled={!agreement.signedAgreementFile}
			href={signedAgreementUrl}
		/>
	);
}
